module.exports = __webpack_public_path__ + "static/mentor-sitaram-f1d0f9844bd9c060a03dcaaf3336a804.png";